module.exports = __webpack_public_path__ + "static/media/labelWithBackgroundColorButtonUp.136a0b1c.svg";